import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Typography,
  Modal,
  LinearProgress,
} from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import ModalContent from "../../../common/components/Modal";
import { useTranslation } from "react-i18next";
import { AssetApi } from "../../../services/netServices";
import { GlobalErrorBox } from "../../../common/components/ErrorBox";

interface ImportToUpdateModalProps {
  open: boolean;
  onClose: () => void;
  onSuccess: () => void;
}

export default function ImportToUpdateModal({
  open,
  onClose,
  onSuccess,
}: ImportToUpdateModalProps) {
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [uploading, setUploading] = useState(false);
  const [errors, setErrors] = useState<string[]>([]);
  const { t } = useTranslation() as any;

  useEffect(() => {
    if (!open) {
      setSelectedFile(null);
      setErrors([]);
    }
  }, [open]);

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0]) {
      setSelectedFile(e.target.files[0]);
      setErrors([]);
    }
  };

  const handleUpload = async () => {
    try {
      setUploading(true);
      setErrors([]);
      const dataLocalStorage = localStorage.getItem("USER");
      const parsedData = JSON.parse(dataLocalStorage ?? "");
      const token = parsedData?.User?.token;
      await new AssetApi().assetImportToUpdatePost(token, selectedFile);
      onSuccess();
      onClose();
    } catch (err: any) {
      console.log(err);
      setErrors([err?.response?.data?.Message || "Import thất bại"]);
    } finally {
      setUploading(false);
    }
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box>
        <ModalContent onClose={onClose} title={t("00_03_import")} width={600}>

          <GlobalErrorBox errors={errors} />

          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              gap: 2,
              py: 3,
            }}
          >
            <Button
              variant="outlined"
              component="label"
              startIcon={<CloudUploadIcon />}
              sx={{ textTransform: "none" }}
            >
              {t("34_00_import_excel")}
              <input
                type="file"
                hidden
                accept={".xlsx,.xls"}
                onChange={handleFileChange}
              />
            </Button>

            {selectedFile && (
              <Typography variant="body2" sx={{ mt: 1, color: "gray" }}>
                {selectedFile.name}
              </Typography>
            )}
          </Box>

          {uploading && <LinearProgress sx={{ mb: 3 }} />}

          <Box display="flex" justifyContent="flex-end" gap={2}>
            <Button
              variant="outlined"
              style={{ borderColor: "#e5e5e5", color: "#000" }}
              onClick={onClose}
            >
              {t("00_03_cancel")}
            </Button>
            <Button
              variant="contained"
              disabled={!selectedFile || uploading}
              onClick={handleUpload}
            >
              {t("00_03_import")}
            </Button>
          </Box>
        </ModalContent>
      </Box>
    </Modal>
  );
}
